import { useCallback } from "react";
import { decodeToken } from "react-jwt";
import { isEmpty } from "lodash";
import { PedidosStorageKeys, useSaurusPedidosStorage } from "./saurus-pedidos-storage";
import { useGetTokenIntegracao } from "../../../data/api/master/integradores/get-token-integracao";

type JwtPayload = {
  exp?: number;
};

export function useTokenIntegracaoGestao() {
  const { exists, getRegistro, setRegistro } = useSaurusPedidosStorage();
  const { getTokenIntegracao } = useGetTokenIntegracao();

  const tokenIntegracaoValido = useCallback((token?: string) => {
    if (!token) return false;
    const payload = decodeToken<JwtPayload>(token);
    if (!payload?.exp) return false;
    return payload.exp * 1000 > new Date().getTime();
  }, []);

  const retornaTokenIntegracao = useCallback(
    async (force: boolean = false): Promise<string> => {
      if (!force && exists(PedidosStorageKeys.TokenIntegracao, false)) {
        const tokenSalvo = getRegistro(PedidosStorageKeys.TokenIntegracao, false);
        if (typeof tokenSalvo === "string" && tokenIntegracaoValido(tokenSalvo)) {
          return tokenSalvo;
        }
      }

      const resp = await getTokenIntegracao();
      if (resp.erro) {
        throw resp.erro;
      }

      const token = resp.resultado?.data?.token ?? resp.resultado?.data;
      if (isEmpty(token) || typeof token !== "string") {
        throw new Error("Token de integração não retornado pela API.");
      }

      setRegistro(PedidosStorageKeys.TokenIntegracao, token, false);
      return token;
    },
    [exists, getRegistro, getTokenIntegracao, setRegistro, tokenIntegracaoValido],
  );

  return {
    retornaTokenIntegracao,
  };
}

